import { useState, useEffect } from 'react';
import MinimalLanding from './MinimalLanding';
import WaterForPlantsLanding from './WaterForPlantsLanding';
// Full landing page saved for later: import WateringCanLanding from './WateringCanLanding';

// ── Route config (change destinations here) ──
// Each route maps to either:
//   - A React component (shows that page, URL stays the same)
//   - An external URL string (redirects to that URL)
const ROUTES = {
  '/moments': WaterForPlantsLanding,   // shows email signup page at /moments
  '/rhythm': 'https://youtu.be/a43vL73yzoQ?si=a9zqeRdsJfDSwnVE',  // redirects externally
  '/plants': WaterForPlantsLanding,    // shows email signup page at /plants
};
function normalize(path) {
  return path.length > 1 ? path.replace(/\/+$/, '') : path;
}

function App() {
  const [page, setPage] = useState(normalize(window.location.pathname));

  useEffect(() => {
    const handlePopState = () => setPage(normalize(window.location.pathname));
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const route = ROUTES[page];

  // External redirect
  useEffect(() => {
    if (typeof route === 'string') {
      window.location.href = route;
    }
  }, [route]);

  if (typeof route === 'string') return null;

  // React component
  if (route) {
    const Component = route;
    return <Component />;
  }

  // All other routes show the minimal landing page
  return <MinimalLanding />;
}

export default App;
